module.exports = __webpack_public_path__ + "static/media/SFX_New_Game_Unlocked_2.041c3eff.mp3";